export default {
  questionnaireId: null,
  inviteId: null,
  forGo: false,
  status: null,
  startTime: null,
  message: "",
  isQuiz: false,
  quizTotal: null,
  quizScore: null,
  score: null,
  items: [],
  showItemsList: false,
  linkedOptionForItem: null,
  divisionInfo: null,
  previousResponse: {},
  isDemo: false,
  isAppEmbed: false,
  autoStart: false,
  preventInviteId: null,
  lastFeedbackId: null,
  stage: null,
  previousStagesResponse: null,
  placeholders: {},
  submittedBy: null,
};
